import { InvalidOrderCard } from "~/order/InvalidOrderCard";

export default function Index() {
  return <InvalidOrderCard />;
}
